import { CSSObject } from 'libs/ui/styled';
import { Colors, Theme } from 'libs/ui/theme';

import { ButtonColorVariant, ButtonSize } from '../types';

import { getStandardMode } from './standard';

const getColorPrimary = () => ({
  bgColor: 'none',
  textColor: Colors.blue500,
  borderColor: Colors.blue500,
  hoverBgColor: Colors.blue50,
  focusBgColor: Colors.blue200,
  hoverTextColor: Colors.blue600,
  hoverBorderColor: Colors.blue600,
  disableBorderColor: Colors.gray300,
  disableTextColor: Colors.black,
});

const getColorGray = () => ({
  bgColor: 'none',
  textColor: Colors.black,
  borderColor: Colors.gray300,
  hoverBgColor: Colors.gray50,
  focusBgColor: Colors.gray100,
  hoverTextColor: Colors.black,
  hoverBorderColor: Colors.gray400,
  disableBorderColor: Colors.gray300,
  disableTextColor: Colors.black,
});

const getColorRed = () => ({
  bgColor: 'none',
  textColor: Colors.red600,
  borderColor: Colors.red600,
  hoverBgColor: Colors.red100,
  focusBgColor: Colors.red200,
  hoverTextColor: Colors.red700,
  hoverBorderColor: Colors.red700,
  disableBorderColor: Colors.gray300,
  disableTextColor: Colors.black,
});

const colorMap: Record<
  ButtonColorVariant,
  ReturnType<typeof getColorPrimary>
> = {
  primary: getColorPrimary(),
  gray: getColorGray(),
  red: getColorRed(),
  blue: getColorPrimary(),
};

export const getOutlinedMode = (
  theme: Theme,
  colorVariant: ButtonColorVariant,
  size: ButtonSize = 'l'
): CSSObject => {
  const colors = colorMap[colorVariant];

  return {
    ...getStandardMode(theme, colorVariant, size),
    backgroundColor: colors.bgColor,
    color: colors.textColor,
    border: `1px solid ${colors.borderColor}`,

    '&:hover': {
      backgroundColor: colors.hoverBgColor,
      borderColor: colors.hoverBorderColor,
      color: colors.hoverTextColor,
    } as CSSObject,

    '&:active': {
      backgroundColor: colors.focusBgColor,
    } as CSSObject,
  };
};
